/**
 * @deprecated Prefer authApi / conductoresApi / apiClient.
 * Se mantiene solo para pantallas no migradas (usuarios admin legacy).
 */
import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export const api = {
  async post(endpoint, data) {
    const response = await apiFetch(`${API_BASE}${endpoint}`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(parseApiError(json, 'Error en la solicitud'));
    }
    return json;
  },

  async get(endpoint) {
    const response = await apiFetch(`${API_BASE}${endpoint}`, {
      headers: authHeaders(),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(parseApiError(json, 'Error en la solicitud'));
    }
    return json;
  },

  async patch(endpoint, data) {
    const response = await apiFetch(`${API_BASE}${endpoint}`, {
      method: 'PATCH',
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(parseApiError(json, 'Error en la solicitud'));
    }
    return json;
  },
};

export { loginWithBackend as authApiLogin } from './authApi';
export * from './conductoresApi';

/** Placeholder — CRUD de admins Nest pendiente (fase posterior). */
export const usersApi = {
  async create() {
    throw new Error('Alta de usuarios admin aún no está conectada al backend Nest');
  },
  async getAll() {
    throw new Error('Consulta de usuarios admin aún no está conectada al backend Nest');
  },
};
